var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('edit-plan-form',{attrs:{"subscription":_vm.subscription,"header-color":"primary"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }